import React, { useEffect, useRef } from 'react';
import twoDigitFormat from '../../../scripts/helpers/two.digit.format';
import Calendar from './calendar';

export const STATS_PERIOD = {

  ALL: 1,
  MONTH: 2,
  CUSTOM: 3,

};

function todayString() {

  const today = new Date();

  return `${ twoDigitFormat( today.getDate() ) }.${ twoDigitFormat( today.getMonth() + 1 ) }.${ today.getFullYear() }`;

}

export function currentMonthBounds() {

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const lastDay = 33 - new Date( year, month, 33 ).getDate();

  return {

    startDate: `01.${ twoDigitFormat( month + 1 ) }.${ year }`,
    endDate: `${ twoDigitFormat( lastDay ) }.${ twoDigitFormat( month + 1 ) }.${ year }`,

  };

}

export function initialPeriodDates() {

  const today = todayString();

  return {

    startDate: today,
    endDate: today,

  };

}

function periodButtonLabel( periodType, startDate, endDate ) {

  if ( periodType !== STATS_PERIOD.CUSTOM ) {

    return 'выбрать период';

  }

  if ( startDate && endDate && startDate === endDate ) {

    return startDate;

  }

  if ( startDate && endDate ) {

    return `${ startDate } - ${ endDate }`;

  }

  return 'выбрать период';

}

const Period = ({

  periodType,
  startDate,
  endDate,
  calendarOpen,
  setCalendarOpen,
  onSelectAll,
  onSelectMonth,
  onSelectCustom,

}) => {

  const rootRef = useRef( null );

  useEffect( () => {

    if ( !calendarOpen ) { return undefined; }

    function handlePointerDown( event ) {

      if ( rootRef.current && !rootRef.current.contains( event.target ) ) {

        setCalendarOpen( false );

      }

    }

    document.addEventListener( 'mousedown', handlePointerDown );
    document.addEventListener( 'touchstart', handlePointerDown );

    return () => {

      document.removeEventListener( 'mousedown', handlePointerDown );
      document.removeEventListener( 'touchstart', handlePointerDown );

    };

  }, [ calendarOpen, setCalendarOpen ] );

  function handleAll() {

    setCalendarOpen( false );
    onSelectAll();

  }

  function handleMonth() {

    setCalendarOpen( false );
    onSelectMonth();

  }

  function handleToggleCalendar() {

    setCalendarOpen( !calendarOpen );

  }

  return (

    <div className = "company-stats__period" ref = { rootRef }>

      {/* <span className = "company-stats__period-label">за:</span> */}

      <div className = "company-stats__period-buttons">

        <button

          type = "button"
          className = { `company-stats__period-btn${ periodType === STATS_PERIOD.ALL ? ' company-stats__period-btn--active' : '' }` }
          onClick = { handleAll }

        >

          всё время

        </button>

        <button

          type = "button"
          className = { `company-stats__period-btn${ periodType === STATS_PERIOD.MONTH ? ' company-stats__period-btn--active' : '' }` }
          onClick = { handleMonth }

        >

          месяц

        </button>

        <button

          type = "button"
          className = { `company-stats__period-btn${ periodType === STATS_PERIOD.CUSTOM ? ' company-stats__period-btn--active' : '' }` }
          onClick = { handleToggleCalendar }

        >

          { periodButtonLabel( periodType, startDate, endDate ) }

        </button>

      </div>

      { calendarOpen &&

        <Calendar

          startDate = { startDate }
          endDate = { endDate }
          onSelectRange = { onSelectCustom }
          onClose = { () => setCalendarOpen( false ) }

        />

      }

    </div>

  );

};

export default Period;
